import { downloadFile } from "@telegram-apps/sdk-react";
import { Icon16Cancel } from "@vkontakte/icons";
import s from "./style.module.scss";
import { Files } from "@/core/reatom/state/currentService/currentService";
import prettyBytes from "pretty-bytes";

import Document from "@/assets/document.svg?react";
import Image from "@/assets/img.svg?react";
import AudioVideo from "@/assets/audioVideo.svg?react";
import {
  IsDocumentFile,
  isImageFile,
  IsSoundFile,
  IsVideoFile,
} from "@/core/helper/mime";
import { getDownloadLink } from "@/core/api/requests/getDownloadLink";
import { FullImageViewer } from "../FullImageViewer/FullImageViewer";
import { usePopout } from "@/core/reatom/state/popout/popout";

export const MessageFiles = ({
  file,
  isReply,
  onDelete,
}: {
  file: Files;
  isReply?: boolean;
  onDelete?: () => void;
}) => {
  const { set } = usePopout();

  return (
    <div>
      {file.mime_type.startsWith("image") && file.url_preview && (
        <img
          src={file.url_preview}
          alt=""
          className={s.images}
          onClick={() =>
            set(
              <FullImageViewer name={file.name} url={file.url_preview || ""} />
            )
          }
        />
      )}
      <div className={s.fileWrapper}>
        <div className={s.download}>
          <div className={s.iconWrapper}>
            {isImageFile(file.mime_type) && <Image />}
            {IsDocumentFile(file.mime_type) && <Document />}
            {IsSoundFile(file.mime_type) ||
              (IsVideoFile(file.mime_type) && <AudioVideo />)}
          </div>
          <div className={s.fileInfo}>
            <p className={s.fileName}>{file.name}</p>
            <div className={s.info}>
              <p className={s.size}>
                {file.size && prettyBytes(file.size, { locale: true })}
              </p>
              {/* {file.url} */}
              {/* {file.url_preview} */}
              {/* <img src={file.url_preview} alt="" /> */}

              {!isReply && (
                <button
                  onClick={async () => {
                    if (downloadFile.isAvailable()) {
                      getDownloadLink(file.id).then(async (res) => {
                        await downloadFile(res.url, file.name);
                      });
                    }
                  }}
                  className={s.downloadButton}
                >
                  Скачать
                </button>
              )}
            </div>
          </div>
        </div>
        {isReply && (
          <button className={s.cancelButton} onClick={onDelete}>
            <Icon16Cancel />
          </button>
        )}
      </div>
    </div>
  );
};
